import { useState } from 'react'
import { Box, Card, CardContent } from '@mui/material'
import { ListAlt } from '@mui/icons-material'

import { useGetEventsReportQuery } from '@/apis/v2Api'
import { useReportArgs } from '@/hooks/useReportArgs'
import type { Period } from '@/utils/dates'
import { BreakdownTable, ReportHeader, ReportStatus } from '@/modules/reports/common'

/** Every event name with counts — v2 `/reports/events`. */
export function EventsPage() {
    const [period, setPeriod] = useState<Period>('7d')
    const args = useReportArgs(period)
    const { data = [], isLoading, error } = useGetEventsReportQuery(args)
    return (
        <Box sx={{ p: 3 }}>
            <ReportHeader
                title="Events"
                subtitle="All event names received in this range."
                period={period}
                onPeriodChange={setPeriod}
            />
            <ReportStatus
                isLoading={isLoading}
                error={error}
                isEmpty={data.length === 0}
                emptyIcon={<ListAlt />}
                emptyTitle="No events in this range"
            >
                <Card>
                    <CardContent>
                        <BreakdownTable rows={data} keyLabel="Event" showValue />
                    </CardContent>
                </Card>
            </ReportStatus>
        </Box>
    )
}
